import {Form, Formik, FormikHelpers, FormikValues} from 'formik';
import React, {useCallback} from 'react';
import UIInput from '../../ui/form/UIInput';
import {
  LOGIN_ERROR_INVALID_CREDENTIALS,
  LOGIN_ERROR_SERVER_UNAVAILABLE,
  LOGIN_ERROR_SERVER_UNEXPECTED_RESPONSE
} from '../../backend';
import {backendUrl, buildQueryString, getQueryParam, getSafeURL, setQueryParams} from '../../utils';
import {useHistory} from 'react-router';
import PrimaryButton from '../../ui/PrimaryButton';
import UILink from '../../ui/UILink';
import * as Yup from 'yup';
import {reverse} from '../../urls';
import {showError} from '../../ui/ToastNotification';

async function fetchLoginAPI(url: string, method?: string, params?: any) {
  method = method || 'GET';
  url = (method !== 'POST') ? url + '?' + buildQueryString(params || {}) : url;
  const headers = (method === 'POST') ? {
    'Content-Type': 'application/x-www-form-urlencoded'
  } : {};
  const body = (method === 'POST') ? buildQueryString(params || {}) : null;

  let response;
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    response = await fetch(backendUrl(url), {method, headers, body});
  } catch (e) {
    throw {
      errorCode: LOGIN_ERROR_SERVER_UNAVAILABLE,
      exception: e,
    }
  }

  let json;
  try {
    json = await response.json();
  } catch (e) {
    console.log(response);
    throw {
      errorCode: LOGIN_ERROR_SERVER_UNEXPECTED_RESPONSE,
      exception: e,
    }
  }
  if (!response.ok) {
    throw {errorCode: (json.error_code || undefined)};
  }

  return json;
}


export default function EmailPasswordForm() {
  const history = useHistory();

  const externalErrorCode = getQueryParam(history, 'err');
  const resetExternalErrorCode = useCallback(() => {
    if (externalErrorCode) {
      setQueryParams(history, {err: null});
    }
  }, [history, externalErrorCode]);

  const onSubmit = useCallback((values: FormikValues, helpers: FormikHelpers<any>) => {
    resetExternalErrorCode();
    fetchLoginAPI('/v2/login-by-credentials', 'POST', {
      username: values.username,
      password: values.password
    }).then((data) => {
      if (data) {
        window.location = getSafeURL(
          getQueryParam(history, '_next'),
          '/dashboard'
        );
      }
      console.log("good");
      console.log(data);
    }).catch((data) => {
      console.log(data);
      if (data?.exception?.message) {
        showError(data?.exception?.message);
      } else if (data.errorCode && data.errorCode === LOGIN_ERROR_INVALID_CREDENTIALS) {
        helpers.setFieldError('username', 'Incorrect email/password');
        helpers.setFieldError('password', 'Incorrect email/password');
      } else {
        showError('Internal error. Please try again later.');
      }
    }).finally(() => {
      helpers.setSubmitting(false);
    })
  }, [history, resetExternalErrorCode]);

  const schema = Yup.object().shape({
    username: Yup.string()
      .required('Required')
      .email('Invalid email'),
    password: Yup.string()
      .required('Required')
  });


  return (
    <Formik initialValues={{username: '', password: ''}} validationSchema={schema} onSubmit={onSubmit}>
      {({isSubmitting}) => (
        <Form>
          <div className="mt-1">
            <UIInput name="username" id="username" placeholder="Email" type="email" autoComplete="username"/>
          </div>
          <div className="space-y-1">
            <div className="mt-1">
              <UIInput name="password" id="password" placeholder="Password" type="password"
                autoComplete="current-password"/>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 mt-10">
            <PrimaryButton className="w-full" loading={isSubmitting}>Login</PrimaryButton>
            <UILink href={reverse('reset-password')} className="text-center w-full pt-2.5">Forgot password?</UILink>
          </div>
        </Form>
      )}
    </Formik>
  )
}
